export default __webpack_public_path__ + "static/media/footer-YoTW@2x.2b1a8782.png";